import * as React from 'react';

interface Props {
  space?: string;
  alignX?: React.CSSProperties['justifyContent'];
  alignY?: React.CSSProperties['alignItems'];
  fillAvailableSpaceY?: boolean;
  fillAvailableSpaceX?: boolean;
}

/**
 * Adds space between elements on Y axis. (Use EvenStack to add space also below and above stack)
 */
export const Stack: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  space,
  alignX,
  fillAvailableSpaceY,
  fillAvailableSpaceX,
}) => {
  return (
    <div
      css={{
        height: fillAvailableSpaceY ? '100%' : 'auto',
        width: fillAvailableSpaceX ? '100%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: alignX,
        '> *': {
          marginBottom: space,
        },
        '> :last-child': {
          marginBottom: 0,
        },
      }}
    >
      {children}
    </div>
  );
};

export const StackItem: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div css={{ marginTop: 'auto' }}>{children}</div>
);
